import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

const services = [
  {
    n: "01",
    title: "Social Media Marketing",
    desc: "Content strategy, community building, and always-on channel design across Instagram, YouTube, and beyond.",
    img: "https://images.unsplash.com/photo-1596205521983-9c372fb3d4f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBiZWF1dHklMjBjYW1wYWlnbiUyMG1vZGVsfGVufDB8fHx8MTc4NDcxNjQ4NHww&ixlib=rb-4.1.0&q=85",
  },
  {
    n: "02",
    title: "Shoot Campaigns",
    desc: "End-to-end creative direction — from concept and casting to art direction, wardrobe, and edit.",
    img: "https://images.unsplash.com/photo-1613915617430-8ab0fd7c6baf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHw0fHxlZGl0b3JpYWwlMjBmYXNoaW9uJTIwcGhvdG9zaG9vdCUyMHN0dWRpb3xlbnwwfHx8fDE3ODQ3MTY0ODR8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    n: "03",
    title: "PR & Styling",
    desc: "Brand seeding, editorial placements, celebrity gifting, and styling that carries the story into culture.",
    img: "https://images.pexels.com/photos/9150031/pexels-photo-9150031.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    n: "04",
    title: "Website Building",
    desc: "Elegant, performance-tuned sites that translate a brand’s voice into a considered digital experience.",
    img: "https://images.unsplash.com/photo-1664076458686-3449062080ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxlZGl0b3JpYWwlMjBmYXNoaW9uJTIwcGhvdG9zaG9vdCUyMHN0dWRpb3xlbnwwfHx8fDE3ODQ3MTY0ODR8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    n: "05",
    title: "Lead Generation",
    desc: "Meta, Google, and creator-led paid media engineered for compounding growth — never at the cost of the brand.",
    img: "https://images.unsplash.com/photo-1677527123243-66c63feb2f14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxhZXN0aGV0aWMlMjBtYWtldXAlMjB0ZXh0dXJlfGVufDB8fHx8MTc4NDcxNjQ4NHww&ixlib=rb-4.1.0&q=85",
  },
];

export const Services = () => {
  const [active, setActive] = useState(null);

  return (
    <section
      id="services"
      className="relative border-t hairline py-24 md:py-40"
      data-testid="services-section"
    >
      <div className="grid grid-cols-12 px-6 md:px-10 lg:px-14 mb-14">
        <div className="col-span-12 md:col-span-3 label">02 — Practice</div>
        <div className="col-span-12 md:col-span-9 font-serif text-4xl md:text-6xl leading-tight text-ink mt-4 md:mt-0">
          <span>What we do,</span>{" "}
          <span className="italic text-mute">meticulously.</span>
        </div>
      </div>

      <div className="relative">
        <ul className="border-t hairline">
          {services.map((s, i) => (
            <li
              key={s.n}
              onMouseEnter={() => setActive(i)}
              onMouseLeave={() => setActive(null)}
              className="border-b hairline"
            >
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.8, ease: EASE, delay: i * 0.04 }}
                className="flex items-center justify-between px-6 md:px-10 lg:px-14 py-8 md:py-10 group cursor-default"
                data-testid={`service-item-${s.n}`}
              >
                <div className="flex items-baseline gap-6 md:gap-10">
                  <span className="font-sans text-xs text-mute">{s.n}</span>
                  <span
                    className={`font-serif text-3xl md:text-6xl leading-none transition-colors duration-500 ${
                      active === i ? "text-ink italic" : "text-ink"
                    }`}
                  >
                    {s.title}
                  </span>
                </div>
                <span className="hidden md:block max-w-sm text-sm text-mute text-right">
                  {s.desc}
                </span>
              </motion.div>
            </li>
          ))}
        </ul>

        {/* Floating image on hover */}
        <div className="hidden lg:block absolute top-0 right-14 h-full pointer-events-none">
          <div className="sticky top-1/3 flex justify-end">
            <AnimatePresence mode="wait">
              {active !== null && (
                <motion.div
                  key={active}
                  initial={{ opacity: 0, y: 30, scale: 0.98 }}
                  animate={{ opacity: 1, y: 0, scale: 1 }}
                  exit={{ opacity: 0, y: -20, scale: 0.98 }}
                  transition={{ duration: 0.6, ease: EASE }}
                  className="w-[300px] aspect-[3/4] overflow-hidden shadow-2xl"
                >
                  <img
                    src={services[active].img}
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
